export default "__VITE_ASSET__COzQ0D6J__"